import { takeLatest } from 'redux-saga/effects';
import { FETCH_REGISTERED_MACHINE_REQUEST } from '../../redux/modules/registeredMachine/registeredMachine-actions';
import fetchRegisteredMachineDetailsWorker from './registeredMachineWorkerSaga';

export default function* fetchRegisteredMachineDetailsWatcher() {
    yield takeLatest(FETCH_REGISTERED_MACHINE_REQUEST, fetchRegisteredMachineDetailsWorker);
}
